export default {"src":"/_next/static/media/file-bank-soal.1e42d79f.svg","height":17,"width":17};